import script from "./PixsoNav.vue?vue&type=script&setup=true&lang=js"
export * from "./PixsoNav.vue?vue&type=script&setup=true&lang=js"

import "./PixsoNav.vue?vue&type=style&index=0&id=a470aefe&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a470aefe"]])

export default __exports__